"use client";

import { Accordion } from "@components/ngg";

import Icon from "./icon";

export default function HistoricalPrice({
  className,
  priceType,
  title,
  text,
}: {
  className?: string;
  priceType?: string;
  title: string;
  text?: string;
}) {
  if (!text) return null;
  if (priceType !== "campaign") return null;
  return (
    <div className="order-14 col-span-12 max-lg:px-4">
      <Accordion
        title={title}
        IconComponent={Icon}
        WrapperComponent="div"
        transitionProps={{ appear: false }}
        classNames={{
          wrapper: className,
          button:
            "text-left items-center leading-4 p-4 font-normal rounded-none",
          panel: "p-4",
        }}
        defaultOpen
      >
        <p className="text-base">{text}</p>
      </Accordion>
    </div>
  );
}
